import { c as _c } from "react/compiler-runtime";
import SvgIcon from '@mui/material/SvgIcon';
import { buttonClasses } from '@mui/material/Button';
import { dialogActionsClasses } from '@mui/material/DialogActions';

// ----------------------------------------------------------------------

/**
 * Icon
 * @see https://icon-sets.iconify.design/eva/chevron-down-fill
 */
const PickerSwitchIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/**
 * Icon
 * @see https://icon-sets.iconify.design/eva/arrow-ios-back-fill
 */
const PickerLeftIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M13.8 19a1 1 0 0 1-.8-.4l-4.8-6a1 1 0 0 1 0-1.2l5-6a1 1 0 0 1 1.6 1.2L10.3 12l4.3 5.4a1 1 0 0 1-.8 1.6" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/**
 * Icon
 * @see https://icon-sets.iconify.design/eva/arrow-ios-forward-fill
 */
const PickerRightIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="m10 19-.6-.2a1 1 0 0 1-.2-1.4l4.5-5.4-4.3-5.4a1 1 0 0 1 .1-1.4 1 1 0 0 1 1.5.2l4.8 6a1 1 0 0 1 0 1.2l-5 6a1 1 0 0 1-.8.4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};

/**
 * Icon
 * @see https://icon-sets.iconify.design/solar/calendar-mark-bold-duotone
 */
const PickerCalendarIcon = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M6.96 2c.42 0 .76.31.76.7v1.39l2.26-.01h4.04l2.26.01v-1.4c0-.38.34-.69.76-.69s.76.31.76.7v1.45c1.45.1 2.4.37 3.1 1 .7.65.98 1.52 1.1 2.85v1H2V8c.12-1.33.4-2.2 1.1-2.84s1.65-.9 3.1-1.01V2.69c0-.38.34-.69.76-.69" />;
    t1 = <path opacity="0.5" fill="currentColor" d="M22 14v-2c0-.84-.01-2.33-.03-3H2.01c-.02.67 0 2.16 0 3v2c0 3.77 0 5.66 1.17 6.83S6.23 22 10 22h4c3.77 0 5.66 0 6.83-1.17S22 17.77 22 14" />;
    t2 = <path fill="currentColor" d="M18 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t0}{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};

/**
 * Icon
 * @see https://icon-sets.iconify.design/solar/clock-circle-outline
 */
const PickerClockIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" fillRule="evenodd" d="M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12a10.75 10.75 0 1 1 21.5 0 10.75 10.75 0 0 1-21.5 0M12 7.25a.75.75 0 0 1 .75.75v3.69l2.28 2.28a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.8.8 0 0 1-.22-.53V8a.75.75 0 0 1 .75-.75" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const defaultProps = {
  date: {
    openPickerIcon: PickerCalendarIcon,
    leftArrowIcon: PickerLeftIcon,
    rightArrowIcon: PickerRightIcon,
    switchViewIcon: PickerSwitchIcon
  },
  time: {
    openPickerIcon: PickerClockIcon,
    rightArrowIcon: PickerRightIcon,
    switchViewIcon: PickerSwitchIcon
  }
};
const MuiDatePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiDateTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiStaticDatePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiDesktopDatePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiDesktopDateTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiMobileDatePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiMobileDateTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.date
  }
};
const MuiTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.time
  }
};
const MuiMobileTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.time
  }
};
const MuiStaticTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.time
  }
};
const MuiDesktopTimePicker = {
  /** DEFAULT PROPS */
  defaultProps: {
    slots: defaultProps.time
  }
};
const MuiPickersLayout = {
  /** STYLE */
  styleOverrides: {
    root: ({
      theme
    }) => ({
      [`& .${dialogActionsClasses.root}`]: {
        [`& .${buttonClasses.root}`]: {
          [`&:last-of-type`]: {
            color: theme.vars.palette.common.white,
            backgroundColor: theme.vars.palette.text.primary,
            ...theme.applyStyles('dark', {
              color: theme.vars.palette.grey[800]
            })
          }
        }
      }
    })
  }
};
const MuiPickersPopper = {
  /** DEFAULT PROPS */
  styleOverrides: {
    paper: ({
      theme
    }) => ({
      boxShadow: theme.vars.customShadows.dropdown,
      borderRadius: theme.shape.borderRadius * 1.5
    })
  }
};
export const datePicker = {
  MuiPickersPopper,
  MuiPickersLayout,
  // Date
  MuiDatePicker,
  MuiDateTimePicker,
  MuiStaticDatePicker,
  MuiDesktopDatePicker,
  MuiDesktopDateTimePicker,
  MuiMobileDatePicker,
  MuiMobileDateTimePicker,
  // Time
  MuiTimePicker,
  MuiMobileTimePicker,
  MuiStaticTimePicker,
  MuiDesktopTimePicker
};